import React from 'react';

interface SpinnerProps {
    height?: string;
    width?: string;
}

const SmallSpinner = ({ height = '10px', width = '10px' }: SpinnerProps) => {
    return (
        <div className={`w-[${width}] h-[${height}] flex items-center justify-center`}>
            <div
                className={`flex justify-center items-center loader w-[${width}] h-[${height}] border-2 border-gray-200 border-t-2 border-t-success110 dark:border-t-success090 rounded-full animate-spin`}
            ></div>
        </div>
    )
};

export default SmallSpinner;
